// Which address finder the API has set up. Tiny and separate, so the staff router
// can fetch it before a form shows (no jump when the finder appears) without
// pulling list queries into the candidate link app.
import { queryOptions } from "@tanstack/react-query";
import { api } from "./api.ts";

export const addressStatusQuery = queryOptions({
	queryKey: ["address-status"],
	queryFn: () => api<{ provider: string | null; mode: "postcode" | "address" | null }>("/public/address/status"),
	staleTime: Number.POSITIVE_INFINITY,
});
